<template>
  <div style="padding:15px;" class="containerTable">
    <vxe-toolbar
      id="toolbarId_ma4"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('userActionList_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('userActionList_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      show-footer
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
                 
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="logtime"
          title="记录时间"
          min-width="120"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.logtime"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="level"
          title="日志级别"
          min-width="50"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.level"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="ip"
          title="ip"
          min-width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.ip"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loginname"
          title="登录账号"
          min-width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.loginname"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="getmethod"
          title="请求方式"
          min-width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.getmethod"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="类型"
          :formatter="formatterType"
          min-width="100"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.type"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="url"
          title="请求连接"
          min-width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.url"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="result"
          title="结果"
          min-width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.result"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="desc"
          title="描述"
          min-width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.desc"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
    import request from '@/utils/request'
    export default {
        name: 'UserActionList',
        components: { },
        data() {
            return {
                message: '',
                loading: false,
                tableData: [],
                exportObj:{
                exportUrl:"/ntocc-es-api/es/exportUserLog",//导出接口
                name:'用户日志',
                methods:'post' 
                },
                listQuery: {
                    logtime: '',
                    thread: '',
                    level: '',
                    classname: '',
                    ip: '',
                    loginname: '',
                    getmethod: '',
                    type: '',
                    url: '',
                    postparams: '',
                    result: '',
                    desc: '',
                    total: 0
                },
                // 类型
                typeOptions: [
                    { label: '越权', value: 'beyond'},
                    { label: 'sql注入', value: 'sql'},
                    { label: '短信', value: 'sms'},
                    { label: '北斗系统', value: 'zjxl'},
                ]
            }
        },
        created() {
            this.findList()
        },
        methods: {
            findList() {
                this.loading = true
                request({
                    url: '/ntocc-es-api/es/findUserLog',
                    method: 'post',
                    data: this.listQuery
                }).then(response => {
                    this.tableData = response.data.records
                    this.listQuery.total = response.data.total
                    this.loading = false
                })
            },
            // 翻译类型
            formatterType({ cellValue }) {
                const item = this.typeOptions.find(item => item.value === cellValue)
                return item ? item.label : ''
            },
        }
    }
</script>

<style>
  
</style>
